module.exports = __webpack_public_path__ + "static/media/2fa-email.d08074f7.svg";